// KARIS Navigation Config
// `module` (a generic CRUD collection) and `page` (a non-CRUD page) map each
// item to a key in the Roles & Permissions system (see PermissionsContext /
// backend permissions.py) -- Sidebar.jsx hides an item its viewer can't see.
// Dashboard has neither: it's the post-login landing page and always visible.
import {
  LayoutDashboard, Users, UserCog, FileText, Receipt, ClipboardList,
  ShoppingCart, Truck, PackageCheck, ArrowLeftRight,
  Calculator, BookOpen, Wallet, TrendingUp, Banknote, ArrowRightLeft,
  Target, AlertCircle, Package, Tag, HardDrive, Wrench, Briefcase, Building2,
  GraduationCap, CalendarOff, CreditCard, CalendarDays,
  LifeBuoy, ClipboardCheck, Coins, ListChecks, BarChart3, Settings,
  FileSpreadsheet, Sofa, Cpu, ScanBarcode, NotebookPen, ListTodo, UserCheck, Gauge,
} from "lucide-react";

export const NAV = [
  { label: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
  {
    // Daily Work Reports & tasks (routes/dwr_routes.py). Review items show
    // only for supervisors and management (dwrReview, see Sidebar.jsx).
    label: "Daily Work",
    icon: NotebookPen,
    children: [
      { label: "My Day", icon: NotebookPen, path: "/dwr/my-day", page: "dwr" },
      { label: "Tasks", icon: ListTodo, path: "/dwr/tasks", page: "dwr" },
      { label: "Team Reports", icon: UserCheck, path: "/dwr/reports", dwrReview: true },
      { label: "Work Dashboard", icon: Gauge, path: "/dwr/dashboard", dwrReview: true },
    ],
  },
  {
    label: "Sales & CRM",
    icon: Target,
    children: [
      { label: "Leads", icon: Target, path: "/crm/leads", module: "leads" },
      { label: "Customers", icon: Users, path: "/crm/customers", module: "customers" },
      { label: "Invoices", icon: Receipt, path: "/crm/invoices", module: "invoices" },
      { label: "Sales", icon: ClipboardList, path: "/crm/sales-orders", module: "sales_orders" },
      { label: "Service Contracts", icon: FileText, path: "/crm/service-contracts", module: "service_contracts" },
    ],
  },
  {
    label: "Purchases",
    icon: ShoppingCart,
    children: [
      { label: "Suppliers", icon: Truck, path: "/purchases/suppliers", module: "suppliers" },
      { label: "Requisitions", icon: ClipboardList, path: "/purchases/requisitions", module: "purchase_requisitions" },
      { label: "Purchase Orders", icon: ShoppingCart, path: "/purchases/orders", module: "purchase_orders" },
      { label: "Supplier Invoices", icon: Receipt, path: "/purchases/invoices", module: "supplier_invoices" },
      { label: "Goods Received", icon: PackageCheck, path: "/purchases/grn", module: "goods_received" },
    ],
  },
  {
    label: "Accounting",
    icon: Calculator,
    children: [
      { label: "Chart of Accounts", icon: BookOpen, path: "/accounting/chart", module: "chart_of_accounts" },
      { label: "Journal Entries", icon: FileText, path: "/accounting/journals", module: "journal_entries" },
      { label: "Expenses", icon: Wallet, path: "/accounting/expenses", module: "expenses" },
      { label: "Deposits", icon: Banknote, path: "/accounting/deposits", module: "deposits" },
      { label: "Fund Transfers", icon: ArrowRightLeft, path: "/accounting/transfers", module: "fund_transfers" },
      { label: "Budgets", icon: TrendingUp, path: "/accounting/budgets", module: "budgets" },
      { label: "Petty Cash", icon: Coins, path: "/accounting/petty-cash", module: "petty_cash" },
    ],
  },
  { label: "Creditors & Debtors", icon: AlertCircle, path: "/creditors-debtors", page: "creditors_debtors" },
  {
    label: "Inventory",
    icon: Package,
    children: [
      // Product Categories moved into Products & Price List (below) --
      // categories only ever exist to group products, so they're managed
      // right where products are, not as a separate Inventory screen.
      { label: "Office Items", icon: Sofa, path: "/inventory/office-items", module: "office_items" },
      { label: "Equipments", icon: Cpu, path: "/inventory/equipments", module: "equipments" },
      { label: "Stock Movements", icon: ArrowLeftRight, path: "/inventory/movements", module: "stock_movements" },
    ],
  },
  {
    label: "Assets",
    icon: HardDrive,
    children: [
      { label: "Asset Register", icon: HardDrive, path: "/assets/register", module: "assets" },
      { label: "Maintenance", icon: Wrench, path: "/assets/maintenance", module: "asset_maintenance" },
    ],
  },
  {
    label: "HRM",
    icon: Briefcase,
    children: [
      { label: "Employees", icon: Users, path: "/hrm/employees", module: "employees" },
      { label: "Departments", icon: Building2, path: "/hrm/departments", module: "departments" },
      { label: "Designations", icon: GraduationCap, path: "/hrm/designations", module: "designations" },
      { label: "Leaves", icon: CalendarOff, path: "/hrm/leaves", module: "leaves" },
      { label: "Payroll", icon: CreditCard, path: "/hrm/payroll", module: "payroll" },
      { label: "Holidays", icon: CalendarDays, path: "/hrm/holidays", module: "holidays" },
    ],
  },
  {
    label: "Service Mgmt",
    icon: LifeBuoy,
    children: [
      { label: "Support Tickets", icon: LifeBuoy, path: "/service/tickets", module: "tickets" },
      { label: "Work Orders", icon: ClipboardCheck, path: "/service/work-orders", module: "work_orders" },
      { label: "Device Registry", icon: ScanBarcode, path: "/service/device-registry", module: "device_installs" },
    ],
  },
  { label: "Approvals", icon: ListChecks, path: "/approvals", page: "approvals" },

  { label: "Products & Price List", icon: Tag, path: "/price-list", module: "products" },
  { label: "Reports", icon: BarChart3, path: "/reports", page: "reports" },
  { label: "Audit Logs", icon: FileSpreadsheet, path: "/audit-logs", page: "audit_logs" },
  { label: "Users & Permissions", icon: UserCog, path: "/users", page: "users" },
  { label: "Settings", icon: Settings, path: "/settings", page: "settings" },
];
